export default function TrajectorySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Projectile motion as game, not equation
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Every physics student meets projectile motion eventually — usually
        as a wall of formulas: x = v₀ cos(θ) t, y = v₀ sin(θ) t − ½gt²,
        a quadratic in t, solve for range, solve for max height, repeat.
        The formulas are right, but they make the parabola look like algebra
        homework instead of what it actually is: the shape of every thrown
        ball, every fountain, every artillery shell since the 17th century.
        Trajectory hands you the parabola directly. You set the angle and
        the speed, you watch the arc, you adjust until you hit the target.
        The shape of the parabola becomes a thing you can feel.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What the levels teach
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Early levels are clean — point at the target, set speed, hit it.
        Middle levels add obstacles: walls, ceilings, gravity wells that
        force you to think about the arc rather than aim straight at the
        target. Late levels have multiple constraints at once and only
        narrow corridors of valid trajectory. Every level has a verified
        solution path (the test suite exhaustively grid-searches all 12
        levels to confirm they're solvable), so if you can't find one,
        keep adjusting — the answer exists.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The two real lessons
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        First — there are usually two valid angles for any target. A high
        lob and a flat shot can both reach the same point. The game makes
        this visible by accepting either, which teaches the symmetry of the
        parabola. Second — air resistance is ignored (the simulation is
        idealized), which means the angle for maximum range is always 45°.
        Real projectiles obey this approximately but air resistance pulls
        the optimum down to ~40° for golf balls and ~30° for shot put.
        The game's idealized physics is exactly the physics in the textbook.
      </p>
    </>
  );
}
